import React from "react";
import { getDefaultUserAvatar } from "winslow-core";
import "./ThreadInfo.css";
import { useValidatedImageUrl } from "../../hooks/useValidatedImageUrl";

type ThreadInfoProps = {
  avatar?: string;
  label: string;
  className?: string;
  onClick?: (employeeId?: string) => void;
  employeeId?: string;
  clickable?: boolean;
  showAvatar?: boolean;
};

export const ThreadInfo = ({
  avatar,
  label,
  className = "",
  onClick,
  employeeId,
  clickable = false,
  showAvatar = true,
}: ThreadInfoProps) => {
  const fallbackAvatar = getDefaultUserAvatar(label);

  const { validatedUrl, isValidating } = useValidatedImageUrl(
    avatar || "",
    fallbackAvatar
  );

  const handleClick = () => {
    if (clickable && onClick && employeeId) {
      onClick(employeeId);
    }
  };

  return (
    <>
      {label === "" ? null : (
        <div
          className={`agent-chat-thread-info ${className} ${clickable ? "clickable" : ""}`}
          onClick={handleClick}
          {...(clickable && { role: "button", tabIndex: 0 })}
          onKeyDown={(e) => {
            if (clickable && (e.key === "Enter" || e.key === " ")) {
              e.preventDefault();
              handleClick();
            }
          }}>
          {showAvatar && (
            <div className="agent-chat-thread-info-avatar">
              {isValidating ? (
                <div className="avatar-loading">...</div>
              ) : (
                <img src={validatedUrl} alt="Thread Avatar" />
              )}
            </div>
          )}
          <div className="agent-chat-thread-info-name">{label}</div>
        </div>
      )}
    </>
  );
};
